import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { Toaster } from './components/ui/sonner';
import { ProtectedRoute, PublicRoute } from './components/ProtectedRoute';
import LandingPage from './pages/LandingPage';
import AuthPage from './pages/AuthPage';
import Dashboard from './pages/Dashboard';
import SubscriptionPage from './pages/SubscriptionPage';
import SubscriptionSuccessPage from './pages/SubscriptionSuccessPage';
import InvoicesPage from './pages/InvoicesPage';
import SettingsPage from './pages/SettingsPage';
import AdminPanel from './pages/AdminPanel';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import CopyrightPage from './pages/CopyrightPage';
import SharedConversationPage from './pages/SharedConversationPage';
import CalculatorPage from './pages/CalculatorPage';
import LawChangesPage from './pages/LawChangesPage';
import FavoritesPage from './pages/FavoritesPage';
import DocumentReviewPage from './pages/DocumentReviewPage';
import KsefPage from './pages/KsefPage';
import TemplatesPage from './pages/TemplatesPage';
import TaxComparisonPage from './pages/TaxComparisonPage';
import JpkAnalysisPage from './pages/JpkAnalysisPage';
import InvoiceAuditorPage from './pages/InvoiceAuditorPage';
import RegulationTranslatorPage from './pages/RegulationTranslatorPage';
import SpecialistBotsPage from './pages/SpecialistBotsPage';
import ImportDataPage from './pages/ImportDataPage';
import IntegrationPage from './pages/IntegrationPage';
import UserGuidePage from './pages/UserGuidePage';
import { useLocation } from 'react-router-dom';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route
              path="/"
              element={
                <PublicRoute>
                  <LandingPage />
                </PublicRoute>
              }
            />
            <Route
              path="/auth"
              element={
                <PublicRoute>
                  <AuthPage />
                </PublicRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/subscription"
              element={
                <ProtectedRoute>
                  <SubscriptionPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/subscription/success"
              element={
                <ProtectedRoute>
                  <SubscriptionSuccessPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/invoices"
              element={
                <ProtectedRoute>
                  <InvoicesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <SettingsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminPanel />
                </ProtectedRoute>
              }
            />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/copyright" element={<CopyrightPage />} />
            <Route path="/share/:shareId" element={<SharedConversationPage />} />
            <Route
              path="/calculator"
              element={
                <ProtectedRoute>
                  <CalculatorPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/law-changes"
              element={
                <ProtectedRoute>
                  <LawChangesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/favorites"
              element={
                <ProtectedRoute>
                  <FavoritesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/review"
              element={
                <ProtectedRoute>
                  <DocumentReviewPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ksef"
              element={
                <ProtectedRoute>
                  <KsefPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/templates"
              element={
                <ProtectedRoute>
                  <TemplatesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/tax-comparison"
              element={
                <ProtectedRoute>
                  <TaxComparisonPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/jpk"
              element={
                <ProtectedRoute>
                  <JpkAnalysisPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/invoice-auditor"
              element={
                <ProtectedRoute>
                  <InvoiceAuditorPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/regulation-translator"
              element={
                <ProtectedRoute>
                  <RegulationTranslatorPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/specialist-bots"
              element={
                <ProtectedRoute>
                  <SpecialistBotsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/import-data"
              element={
                <ProtectedRoute>
                  <ImportDataPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/integrations"
              element={
                <ProtectedRoute>
                  <IntegrationPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/guide"
              element={
                <ProtectedRoute>
                  <UserGuidePage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
